import * as _ from "lodash";
import * as Backbone from "backbone";
import {BaseView} from "../_BaseViews";
import {PermissionCollection} from "../../collections/Permissions";
import {Module} from "../../models/Module";
import {DashboardChannelCollection} from "../../collections/DashboardChannels";
import {DashboardWidgetCollection} from "../../collections/DashboardWidgets";
import {ChartView} from "../dashboard/widgets/chart/ChartView";
import {
    CHART_AGGREGATION_PERIOD,
    CHART_AGGREGATION_TYPE,
    CHART_CONNECT_TO_TILES,
    CHART_CONVERT_ALL_DATA,
    CHART_DATA_RANGE,
    CHART_DATA_ZOOM,
    CHART_HIDE_SINGLE_GAPS,
    CHART_REAL_TIMESTAMPS,
    CHART_SIZE,
    CHART_TYPE
} from "../dashboard/widgets/chart/ChartHelper";
import {ChartWorkerManager} from "../dashboard/widgets/ChartWorkerManager";
import {WidgetTool} from "../../common/widgetTool";
import {StatusView} from "./StatusView";
import {User} from "../../models/User";

require('highstock.nodata');
require('highstock');


interface StatusChartViewOptions extends Backbone.ViewOptions<Backbone.Model> {
    parentView: StatusView;
    permissionCollection: PermissionCollection;
    currentUser: User;
}

export class StatusChartView extends BaseView {

    model: Module;
    options: StatusChartViewOptions;

    private template = _.template(require('templates/status/chartView.html'));
    private chartView: ChartView;
    private dashboardChannelCollection: DashboardChannelCollection;
    private chartWidget;
    private dashboardWidgetCollection: DashboardWidgetCollection;
    private chartWorkerManager: ChartWorkerManager;
    private dashboardChannelIds: number[] = [];

    constructor(options: StatusChartViewOptions) {

        super(<any> _.extend(options, {
            tagName: "div",
            events: {
                'click #status-chart-close': 'hideChart'
            }
        }));

        this.dashboardWidgetCollection = new DashboardWidgetCollection();
        this.chartWidget = WidgetTool.createWidget('chart', {
                dashboard_category_id: 0,
                dashboard_id: 0,
                dashboard_widget_type_id: 4,
                id: null,
                order: 1,
                type: 'chart',
                params: {
                    CHART_TIMESTAMPS: CHART_REAL_TIMESTAMPS.ENABLED,
                    CHART_DATA_ZOOM: CHART_DATA_ZOOM.DEFAULT,
                    CHART_TYPE: CHART_TYPE.DEFAULT,
                    CHART_CONNECT_TO_TILES: CHART_CONNECT_TO_TILES.CONNECT_TO_ALL,
                    CHART_AGGREGATION_PERIOD: CHART_AGGREGATION_PERIOD.DEFAULT,
                    CHART_AGGREGATION_TYPE: CHART_AGGREGATION_TYPE.DEFAULT,
                    CHART_SIZE: CHART_SIZE.SIZE_6,
                    CHART_DATA_RANGE: CHART_DATA_RANGE.WEEK_1,
                    CHART_CONVERT_ALL_DATA: CHART_CONVERT_ALL_DATA.ENABLED,
                    CHART_HIDE_SINGLE_GAPS: CHART_HIDE_SINGLE_GAPS.DISABLED
                }
            });

        this.dashboardWidgetCollection.add(this.chartWidget);
        this.dashboardChannelCollection = new DashboardChannelCollection();
        this.chartWorkerManager = new ChartWorkerManager({
            dashboardChannelCollection: this.dashboardChannelCollection
        });

        this.$el.html(this.template());
        this.updateDashboardChannels();
    }

    updateDashboardChannels(){
         var dashboardChannels = _.map(this.model.getChannels(), (channel, i) => {
            return _.extend({
                dashboard_category_id: 0,
                dashboard_channel_dashboard_id: 0,
                dashboard_channel_id: Number(String(channel['channel_id'])),
                dashboard_channel_name: channel['channel_name'],
                dashboard_channel_order: i,
                dashboard_channel_secondary_order: i,
                dashboard_widget_id: null
            }, channel)
        });

        this.dashboardChannelCollection.set(dashboardChannels);
    }

    showChart(connector, channels) {
        // Render the chart view if we haven't already
        this.renderChartView();

        // Add and remove channels
        var currentDashboardChannelIds = [];
        _.each(channels, (channelId) => {
            var tempDashboardChannel = this.dashboardChannelCollection.findWhere({'channel_id':channelId});
            if(tempDashboardChannel) currentDashboardChannelIds.push(tempDashboardChannel.get('dashboard_channel_id'));
        });

        _.each(_.difference(this.dashboardChannelIds, currentDashboardChannelIds), (oldId) => {
            window['App'].Bus.trigger('dashboard:category:all:chart:removeChannel', oldId);
        });

        _.each(_.difference(currentDashboardChannelIds, this.dashboardChannelIds), (newId) => {
            window['App'].Bus.trigger('dashboard:category:all:chart:addChannel', newId);
        });
        this.dashboardChannelIds = currentDashboardChannelIds;
        this.chartView.reflow();
    }

    hideChart() {
        this.options.parentView.hideChart();
    }

    render() {
        this.delegateEvents();
        return this;
    }

    renderChartView() {
        if(this.chartView) return;

        if ($(document).height() >= 720 && $(document).width() >= 975) {
            // Set to fix width and affix if the client height supports it
            (<any> this.$el.width(this.$el.width())).affix({
                offset: {
                    top: this.$el.offset().top - 50
                }
            });
        }

        this.chartView =  new ChartView({
            dashboardWidgetCollection: this.dashboardWidgetCollection,
            dashboardChannelCollection: this.dashboardChannelCollection,
            permissionCollection: this.options.permissionCollection,
            widget: this.chartWidget,
            dashboardId: 0,
            categoryId: 0,
            widgetId: this.chartWidget,
            parentView: this,
            currentUser: this.options.currentUser,
            chartWorkerManager: this.chartWorkerManager,
            manager: null,
            editable: false,
            cloneable: false,
            movable: false,
            deletable: false
        });
        this.$('#status-chart-chart').append(this.chartView.$el);
        this.chartView.render();

    }

    remove() {
        this.chartWorkerManager.reset();
        this.stopListening();
        this.chartView.remove();
        return super.remove();
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/status/StatusChartView.ts